<script setup lang="ts">
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useForm } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/yup'
import { codeSchema } from '@/types'

const props = defineProps({
  email: {
    type: String,
    required: true,
  },
})

const store = useStore()

const wrongCode = ref(false)
const loading = ref(false)

const validationSchema = toTypedSchema(codeSchema)
const { handleSubmit, errors, defineField } = useForm({
  validationSchema,
})
const [code] = defineField('code')

const sendCode = handleSubmit(async (values) => {
  loading.value = true

  try {
    await store.dispatch('auth0PasswordlessLogin', {
      email: props.email,
      verificationCode: values.code,
    })
    window.scroll(0, 0)
  } catch (error) {
    wrongCode.value = true
  }

  loading.value = false
})
</script>

<template>
  <form
    :aria-label="$t('Login.CodeForm.AriaLabel')"
    class="mt-4"
    data-testid="code-form"
    novalidate
    @submit.prevent="sendCode"
  >
    <div class="form-wrapper col col-sm-8 mx-auto text-start position-relative">
      <label for="code" class="mb-1">
        {{ $t('Login.CodeForm.CodeInput.Label') }}
      </label>
      <input
        id="code"
        v-model="code"
        name="code"
        class="form-control"
        :class="{ input: true, 'is-invalid': errors.code?.length || wrongCode }"
        maxlength="6"
        minlength="6"
        spellcheck="false"
        autofocus
        autocomplete="one-time-code"
        :placeholder="$t('Login.CodeForm.CodeInput.Placeholder')"
        @focus="wrongCode = false"
      />
      <div
        v-if="wrongCode"
        class="text-danger small position-absolute text-center"
      >
        {{ $t('Login.CodeForm.CodeError') }}
      </div>
    </div>

    <div class="mt-3 col col-sm-8 mx-auto">
      <button
        type="submit"
        :disabled="loading"
        class="btn btn-primary btn-block"
      >
        <span
          v-if="loading"
          class="spinner-border spinner-border-sm me-2"
          aria-hidden="true"
        ></span>
        <span>
          {{ $t('Login.CodeForm.SubmitButton.Text') }}
        </span>
      </button>
    </div>
  </form>
</template>
